import React, { Component } from "react";
import { connect } from "react-redux";
import { Col, Row, Form, Spinner } from "react-bootstrap";

import {
  httpGetDownloadFileByVendorId,
  httpPostGenerateContract,
} from "../../../../service/httpClient";
import DownloadDocument from "./DownloadDocument/DownloadDocument";
import Header from "../TabHeader/TabHeader";
import * as Constants from "../../../../constants/Constants";
import Uploadwindow from "./UploadDocuments/uploadwindow/Uploadwindow";
import AppContext from "../../../../context/appcontext";
import * as RolePermissionConstants from "../../../../constants/RolePermissionConstants";
import { getUserRolePermission } from "../../../../utils/rolePermissionAccess";
import ErrorContainer from "../../../Common/Errors/ErrorContainer";
import { convertDate } from "../../../../utils/DateUtility";
import "./DocumentCenter.css";
import { checkOnBoardingStatus } from "../../../../utils/utils";
import { VendorContract } from "./VendorContract";
import ManageContract from "./ManageContract";
import { getBlmDept, getMacyDept, verifyIfCheckedUnchecked } from "../../OnboardingHelper";

class DocumentCenter extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {
      modalShow: false,
      reqDocumentCheck: [],
      documentList: [],
      isFetching: false,
      isError: false,
      errorMessage: "",
    };
  }

  componentDidMount() {
    const { vendorId } = this.props;

    if (vendorId !== "null") {
      this.fetchData(vendorId);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.vendorDetails !== this.props.vendorDetails)
      this.setRequiredDocs();
    if (prevState.documentList !== this.state.documentList)
      this.setRequiredDocs();
  }

  componentWillUnmount() {
    this.props.getDocumentList(this.props?.vendorId);
  }

  setRequiredDocs = () => {
    const { vendorDetails = {} } = this.props;
    let hasClassLevelMapping = null;
    let freightTermExplanationDocRequired = null;
    const {
      needDVN = "false",
      certifiedAsMinority,
      merchandiseType = "",
      vendorConnectionPlatform = "",
      hierarchyDetails,
    } = vendorDetails;
    if (hierarchyDetails && hierarchyDetails.length > 0) {
      hasClassLevelMapping = hierarchyDetails.find(
        (item) =>
          item.brandName &&
          item.brandName === Constants.MERCHANT_CLASS_LEVEL_MAPPING
      );
      freightTermExplanationDocRequired = hierarchyDetails.find(
        (item) =>
          item.operatingDivision &&
          item.operatingDivision === Constants.MACYS &&
          item.freightCode &&
          !(
            item.freightCode === Constants.FREIGHT_CODE_100 ||
            item.freightCode === Constants.FREIGHT_CODE_PRPD
          )
      );
    }
    let reqDocumentArr = [];

    if (needDVN !== "false" && needDVN !== "") {
      reqDocumentArr = [
        {
          label: "Compliance Letter",
          value: "ComplianceLetter",
          checked: false,
        },
        {
          label: "Continuing Guaranty",
          value: "ContinuingGuaranty",
          checked: false,
        },
        {
          label: "Blank Invoice or Company Letterhead",
          value: "BlankInvoice/CompanyLetterhead",
          checked: false,
        },
      ];

      if (certifiedAsMinority)
        reqDocumentArr.push({
          label: "MBE/WBE Documentation",
          value: "MBE/WBEBusinessDocumentation",
          checked: false,
        });
    }

    if (
      merchandiseType === Constants.VENDOR_FULFILLMENT_TYPE &&
      vendorConnectionPlatform !== Constants.NEW_BIG_TKT_VENDOR_FLAG &&
      vendorConnectionPlatform !== Constants.BIG_TKT_VENDOR_FLAG
    ) {
      reqDocumentArr.push(
        {
          label: "Signed VDF Contract",
          value: "SignedVDFContract",
          checked: false,
        },
        {
          label: "UPS Shipping Information",
          value: "UPSShippingInformation",
          checked: false,
        }
      );
    }

    if (
      merchandiseType === Constants.VENDOR_FULFILLMENT_TYPE &&
      vendorConnectionPlatform === Constants.NEW_BIG_TKT_VENDOR_FLAG
    ) {
      reqDocumentArr.push({
        label: "UPS Shipping Information",
        value: "UPSShippingInformation",
        checked: false,
      });
    }

    if (
      needDVN &&
      (needDVN === "true" || needDVN === "false") &&
      merchandiseType === Constants.VENDOR_FULFILLMENT_TYPE &&
      vendorConnectionPlatform === Constants.STATUS_PLATFORMTYPE_DIRECTEDI
    ) {
      reqDocumentArr.push({
        label: "Test UPC Document",
        value: "TestUPCDocument",
        checked: false,
      });
    }

    if (
      merchandiseType === Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE &&
      Constants.STATUS_PLATFORMTYPE_MIRAKL.includes(vendorConnectionPlatform)
    ) {
      reqDocumentArr = [];
      reqDocumentArr = [
        {
          label: "W9",
          value: "W9",
          checked: false,
        },
      ];
    }

    if (hasClassLevelMapping) {
      reqDocumentArr.push({
        label: "Brand Mapping Template",
        value: "BrandMappingTemplate",
        checked: false,
      });
    }

    if (
      merchandiseType &&
      merchandiseType !== Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE &&
      freightTermExplanationDocRequired
    ) {
      reqDocumentArr.push({
        label: "Freight Terms Explanation",
        value: "FreightTermsExplanation",
        checked: false,
      });
    }
    const primaryMerchantEmail =
      this.props?.vendorProfile?.merchantContact?.email || "";
    const isVendorEligible =
      this.rolePermissionForChannelProfitCalculator() ===
        RolePermissionConstants.EDIT &&
      merchandiseType === Constants.VENDOR_FULFILLMENT_TYPE &&
      primaryMerchantEmail?.endsWith("@macys.com");
    if (isVendorEligible) {
      reqDocumentArr.push({
        value: "ChannelProfitCalculator",
        label: "Channel Profit Calculator",
        checked: false,
      });
    }
    if (reqDocumentArr && reqDocumentArr.length > 0) {
      this.setDocumentCheck(reqDocumentArr);
    }
  };

  setDocumentCheck = (reqDocumentCheck) => {
    const { documentList = [] } = this.state;
    let updatedReqDocument = [];

    if (documentList && documentList.length > 0) {
      updatedReqDocument =
        reqDocumentCheck &&
        reqDocumentCheck.length > 0 &&
        reqDocumentCheck.map((reqDocument) => {
          let flag = false;
          if (
            reqDocument.value !== Constants.BLANK_INVOICE_OR_COMPANY_LETTERHEAD
          ) {
            flag = documentList.some(
              (document) => document.fileType === reqDocument.value
            );
          } else {
            flag = documentList.some(
              (document) =>
                document.fileType === Constants.BLANK_INVOICE ||
                document.fileType === Constants.COMPANY_LETTERHEAD
            );
          }
          return {
            label: reqDocument.label,
            value: reqDocument.value,
            checked: flag,
          };
        });
    } else {
      updatedReqDocument = reqDocumentCheck;
    }

    this.setState({ reqDocumentCheck: updatedReqDocument });
  };

  documentTypeRename = (data) => {
    const documentArr = data.map((p) =>
      p.fileType === Constants.MINORITY_BUSINESS_DOCUMENTATION
        ? { ...p, fileType: "MBE/WBEBusinessDocumentation" }
        : p
    );

    return documentArr;
  };

  setFetching = (isFetching) => {
    this.setState({ isFetching });
  };

  fetchData = (vendorId) => {
    this.setState({ isFetching: true });
    const data = [];
    httpGetDownloadFileByVendorId(vendorId)
      .then((response) => {
        response.data.forEach((rec) => {
          let date = convertDate(rec.updatedAt);
          rec.updatedAt = date;
          data.push(rec);
        });

        let documentArr = this.documentTypeRename(data);
        const isAllowToShowExipryDate = getUserRolePermission(
          RolePermissionConstants.VENDORPLATFORM_PREBOARDING_DOCUMENTCENTER,
          RolePermissionConstants.EXPIRATION_DATE
        );
        if (isAllowToShowExipryDate === Constants.EDIT) {
          const filterdData = documentArr.filter((item) => {
            item.isAllowToDelete = true;
            return item.fileType === Constants.MBE_WBE_BUSINESSDOCUMENTATION;
          });
          const filterdDataWithoutMEB = documentArr.filter(
            (item) => item.fileType !== Constants.MBE_WBE_BUSINESSDOCUMENTATION
          );
          const statusDetailSort = filterdData.sort(
            (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
          );
          if (statusDetailSort && statusDetailSort.length >= 1) {
            statusDetailSort[0].isAllowToDelete = false;
          }
          documentArr = [...filterdDataWithoutMEB, ...statusDetailSort];
        } else {
          documentArr = documentArr.map((item) => {
            item.isAllowToDelete = false;
            return item;
          });
        }
        if (
          this.rolePermissionForChannelProfitCalculator() !==
          RolePermissionConstants.EDIT
        ) {
          documentArr = documentArr.filter(
            (item) => item.fileType !== "ChannelProfitCalculator"
          );
        }
        this.setState({ documentList: documentArr, isFetching: false });
      })
      .catch((error) => {
        this.setState({ documentList: [], isFetching: false });
      });
  };
  handleShowViewModifyModal = () => {
    this.setState({ ...this.state, showModal: true });
  };
  handleCloseViewModifyModal = () => {
    this.setState({ ...this.state, showModal: false });
  };
  handleGenerateContract = (fileContent, contractType) => {
    this.setFetching(true);
    const {
      vendorDetail,
      primaryContact,
      mailAddress,
      mbeWbeVendorDetails
    } = this.props.vendorProfile || {};
    
    const {
      id,
      vendorCorpName,
      brandName,
      merchandiseType,
      hierarchyDetails = [],
      duns,
      companyType,
      submittedBy
    } = vendorDetail || {};

    const { firstName, lastName, role, phoneNumber } = primaryContact || {};
    const { streetAddress, city, state, zipCode, email } = mailAddress || {};

    const {
      fax,
      federalId,
      website,
      ceoEmail,
      avgEmployees,
      avgCompletedSales,
      mbeStatus,
      mbeGroups,
      wbeStatus,
      organization,
    } = mbeWbeVendorDetails || {};

    const payload = {
      vendorProfileId: id || null,
      vendorCorpName: vendorCorpName || null,
      brandName: brandName || null,
      merchandiseType: merchandiseType || null,
      vendorPrimaryContactName: firstName + " " + lastName || null,
      vendorPrimaryRole: role || null,
      mailingStreetAddress: streetAddress || null,
      city: city || null,
      state: state || null,
      zipCode: zipCode || null,
      vendorContractEmail: contractType && contractType === Constants.DEI_TYPE
      ? ceoEmail
      : email,
      mcyDivision: getMacyDept(hierarchyDetails) != "" ? "Macy's" : null,
      mcyDept: getMacyDept(hierarchyDetails),
      blmDivision: getBlmDept(hierarchyDetails) != "" ? "Bloomingdale's" : null,
      blmDept: getBlmDept(hierarchyDetails),
      mcyVendorNbr: 0,
      blmVendorNbr: 0,
      duns: duns || "",
      companyType: companyType || "",
      contractType:
        contractType !== "undefined" && contractType
          ? contractType
          : Constants.CONSIGNMENT_TYPE,
      vendorSignOrder:
        typeof Constants.VENDOR_SIGN_ORDER[contractType] !== "undefined"
          ? Constants.VENDOR_SIGN_ORDER[contractType]
          : 2,
      vpSignOrder:
        typeof Constants.VP_SIGN_ORDER[contractType] !== "undefined"
          ? Constants.VP_SIGN_ORDER[contractType]
          : 1,
      fax: fax || "",
      federalId: federalId || "",
      website: website || "",
      ceoEmail: ceoEmail || "",
      merchantContractEmail: Constants.TEST_CONSIGNMENT_APVP_EMAIL,
      avgEmployees: avgEmployees || "",
      avgCompletedSales: avgCompletedSales || "",
      primaryPhone: phoneNumber || "",
      mbeWbeContractModel: {
        isMbeChecked: verifyIfCheckedUnchecked(
          Constants.FLAGS_MBE_STATUS.MINORITY_OWNED,
          mbeStatus
        ),
        isNonMbeChecked: verifyIfCheckedUnchecked(
          Constants.FLAGS_MBE_STATUS.NOT_MINORITY_OWNED,
          mbeStatus
        ),

        isAsianPacificChecked: verifyIfCheckedUnchecked(
          Constants.FLAGS_MBE_GROUPS.ASIAN_PACIFIC_AMERICAN,
          mbeGroups
        ),
        isAsianIndChecked: verifyIfCheckedUnchecked(
          Constants.FLAGS_MBE_GROUPS.ASIAN_INDIAN_AMERICAN,
          mbeGroups
        ),
        isBlckChecked: verifyIfCheckedUnchecked(
          Constants.FLAGS_MBE_GROUPS.BLACK_AFRICAN_AMERICAN,
          mbeGroups
        ),
        isHispanicChecked: verifyIfCheckedUnchecked(
          Constants.FLAGS_MBE_GROUPS.HISPANIC_AMERICAN,
          mbeGroups
        ),
        isNativeChecked: verifyIfCheckedUnchecked(
          Constants.FLAGS_MBE_GROUPS.NATIVE_AMERICAN,
          mbeGroups
        ),
        isLGBTQChecked: verifyIfCheckedUnchecked(
          Constants.FLAGS_MBE_GROUPS.LGBTQ,
          mbeGroups
        ),
        isDisablityChecked: verifyIfCheckedUnchecked(
          Constants.FLAGS_MBE_GROUPS.PERSON_DISABILITY,
          mbeGroups
        ),
        isVeteranChecked: verifyIfCheckedUnchecked(
          Constants.FLAGS_MBE_GROUPS.VETERAN,
          mbeGroups
        ),

        isWbeChecked: verifyIfCheckedUnchecked(
          Constants.FLAGS_WBE_STATUS.WOMEN_OWNED,
          wbeStatus
        ),
        isNonWbeChecked: verifyIfCheckedUnchecked(
          Constants.FLAGS_WBE_STATUS.NOT_WOMEN_OWNED,
          wbeStatus
        ),

        isMcyChecked: verifyIfCheckedUnchecked(
          Constants.FLAGS_BUSINESS_ORGS.MACYS,
          organization
        ),
        isBlmChecked: verifyIfCheckedUnchecked(
          Constants.FLAGS_BUSINESS_ORGS.BLOOMS,
          organization
        ),
        isBlueMercuryChecked: verifyIfCheckedUnchecked(
          Constants.FLAGS_BUSINESS_ORGS.BLUEM,
          organization
        ),
      },
    };
    fileContent ? (payload["fileContent"] = fileContent) : "";
    httpPostGenerateContract(payload, contractType)
      .then((response) => {
        this.fetchData(this.props?.vendorId);
      })
      .catch((error) => {
        this.setState({
          errorMessage: error.response?.data?.message,
          isError: true,
        });
        this.setFetching(false);
      });
  };

  rolePermissionForGenerateContract = () =>
    getUserRolePermission(
      RolePermissionConstants.VENDORPLATFORM_PREBOARDING_DOCUMENTCENTER,
      RolePermissionConstants.VMP_GENERATE_CONTRACT
    );

  rolePermissionForViewModifyContract = () =>
    getUserRolePermission(
      RolePermissionConstants.VENDORPLATFORM_PREBOARDING_DOCUMENTCENTER,
      RolePermissionConstants.VMP_GENERATE_CONTRACT
    );

  rolePermissionForChannelProfitCalculator = () =>
    getUserRolePermission(
      RolePermissionConstants.VENDORPLATFORM_PREBOARDING_DOCUMENTCENTER,
      RolePermissionConstants.VMP_ADDDOCUMENT_CHANNEL_PROFIT_CALCULATOR
    );

    handleShowGenerateDeiContractModal = () => {
      this.setState({ ...this.state, showDeiModal: true });
    };
    handleCloseGenerateDeiContractModal = () => {
      this.setState({ ...this.state, showDeiModal: false });
    };
  
  render() {
    const pageAccessBasedOnRole =
      getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_PREBOARDING_DOCUMENTCENTER,
        RolePermissionConstants.VMP_PAGEACCESS
      ) === RolePermissionConstants.VIEW;

    return (
      <fieldset
        disabled={this.props.onboardingStatusFlag && !pageAccessBasedOnRole}
      >
        {this.state?.isFetching ? (
          <Spinner
            animation="border"
            variant="danger"
            style={{
              width: "50px",
              height: "50px",
              marginRight: 5,
              position: "absolute",
              top: "32vh",
              left: "28vw",
            }}
          />
        ) : (
          <React.Fragment>
            {getUserRolePermission(
              RolePermissionConstants.VENDORPLATFORM_PREBOARDING_DOCUMENTCENTER,
              RolePermissionConstants.ALL
            ) !== RolePermissionConstants.NONE && (
              <div>
                {this.state.isError && (
                  <ErrorContainer
                    errorMsg={this.state.errorMessage}
                    errorStatus={true}
                    errorStyle="errorMessage"
                  />
                )}
                <Row className="documentCenterAddDoc">
                  <div className="flexContainer documentCenterReqList">
                    {this.state.reqDocumentCheck &&
                      this.state.reqDocumentCheck.length > 0 && (
                        <div className="flexChild documentCenterReqCheck">
                          <div style={{ paddingBottom: "10px" }}>
                            The following documents are required for approval by
                            Accounts Payable:
                          </div>
                          {this.state.reqDocumentCheck.map(
                            (reqDocument, index) => {
                              return (
                                <Form.Check
                                  inline
                                  type="checkbox"
                                  label={reqDocument?.label}
                                  name={`reqDocument${index}`}
                                  className="documentCenterCheckbox"
                                  checked={reqDocument?.checked}
                                  disabled
                                  key={`reqDocument-${index}`}
                                />
                              );
                            }
                          )}
                        </div>
                      )}
                    {this.rolePermissionForViewModifyContract() ===
                      RolePermissionConstants.EDIT &&
                      this.props?.vendorProfile?.vendorDetail
                        ?.merchandiseType ===
                        Constants.VOB_MERCHANDISE_TYPE_CONSIGNMENT && (
                        <Col>
                          <Row>
                            <ManageContract
                              vendorProfile={this.props?.vendorProfile}
                              showModal={this.state.showModal}
                              handleCloseViewModifyModal={
                                this.handleCloseViewModifyModal
                              }
                              handleGenerateContract={
                                this.handleGenerateContract
                              }
                              contractType={Constants.CONSIGNMENT_TYPE}
                            />
                          </Row>
                        </Col>
                      )}

                    {/**DEI Contract Modal */}
                    {this.props.vendorDetails?.certifiedAsMinority &&
                      getUserRolePermission(
                        RolePermissionConstants.VENDORPLATFORM_PREBOARDING_DOCUMENTCENTER,
                        RolePermissionConstants.VMP_GENERATE_BMEWBE_CONTRACT
                      ) === RolePermissionConstants.VIEW && (
                        <Col>
                          <Row>
                            <ManageContract
                              vendorProfile={this.props?.vendorProfile}
                              showModal={this.state.showDeiModal}
                              handleCloseViewModifyModal={
                                this.handleCloseGenerateDeiContractModal
                              }
                              handleGenerateContract={
                                this.handleGenerateContract
                              }
                              contractType={Constants.DEI_TYPE}
                            />
                          </Row>
                        </Col>
                      )}
                    {/**End DEI Contract Modal */}
                  </div>
                </Row>
                <Row>
                  <div className="flexContainer">
                    <div className="flexChild addDocumentBtn">
                      <button
                        onClick={() => this.setState({ modalShow: true })}
                        className="addDocBtn"
                        disabled={
                          !(
                            getUserRolePermission(
                              RolePermissionConstants.VENDORPLATFORM_PREBOARDING_DOCUMENTCENTER,
                              RolePermissionConstants.ALL
                            ) === RolePermissionConstants.EDIT
                          )
                        }
                      >
                        {Constants.ADD_DOCUMENT}
                      </button>
                    </div>
                    {this.props.vendorDetails?.certifiedAsMinority &&
                      this.props.vendorDetails?.isPrimaryVendor &&
                      this.props.vendorDetails?.isAffidavit &&
                      checkOnBoardingStatus(this.props.onboardingStatus, [
                        Constants.MERCHANT_APPROVED,
                      ]) &&
                      getUserRolePermission(
                        RolePermissionConstants.VENDORPLATFORM_PREBOARDING_DOCUMENTCENTER,
                        RolePermissionConstants.VMP_GENERATE_BMEWBE_CONTRACT
                      ) === RolePermissionConstants.VIEW && (
                        <div className="flexChild viewModifyContract">
                          <button
                            className="generateContractBtn"
                            onClick={() =>
                              this.handleShowGenerateDeiContractModal()
                            }
                          >
                            {Constants.VIEW_MBEWBE_CONTRACT}
                          </button>
                        </div>
                      )}
                    {this.rolePermissionForViewModifyContract() ===
                      RolePermissionConstants.EDIT &&
                      this.props?.vendorProfile?.vendorDetail
                        ?.merchandiseType ===
                        Constants.VOB_MERCHANDISE_TYPE_CONSIGNMENT &&
                      checkOnBoardingStatus(this.props.onboardingStatus, [
                        Constants.CONSIGNMENT_ADMIN_PENDING,
                        Constants.ACCOUNTS_PAYABLE_VP_PENDING,
                        Constants.CONSIGNMENT_VENDOR_PENDING,
                      ]) && (
                        <div className="flexChild viewModifyContract">
                          <button
                            onClick={() => this.handleShowViewModifyModal()}
                            className="generateContractBtn"
                          >
                            {Constants.VIEW_MODIFY_CONTRACT}
                          </button>
                        </div>
                      )}
                    {getUserRolePermission(
                      RolePermissionConstants.VENDORPLATFORM_PREBOARDING_DOCUMENTCENTER,
                      RolePermissionConstants.VMS_REVIEW_CONSIGNMENT_CONTRACT
                    ) === RolePermissionConstants.EDIT && (
                      <VendorContract
                        vendorId={this.props?.vendorId}
                        onboardingStatus={this.props?.onboardingStatus}
                        refreshDataAfterActionSuccessful={
                          this.props?.refreshDataAfterActionSuccessful
                        }
                      />
                    )}
                  </div>
                </Row>
                <Row>
                  <Col>
                    <DownloadDocument
                      vendorId={this.props.vendorId}
                      dataRefreshHandler={this.props.dataRefreshHandler}
                      fetchData={this.fetchData}
                      documentList={this.state.documentList}
                      vendorDetails={this.props.vendorDetails}
                      duns={this.props.duns}
                      disabled={
                        this.props.onboardingStatusFlag &&
                        !pageAccessBasedOnRole
                      }
                      isFetching={this.state?.isFetching || false}
                      setFetching={this.setFetching}
                    />
                  </Col>
                </Row>

                <Uploadwindow
                  show={this.state.modalShow}
                  onHide={() => this.setState({ modalShow: false })}
                  vendorId={this.props.vendorId}
                  duns={this.props.duns}
                  vendorName={this.props.vendorCorpName}
                  fetchData={this.fetchData}
                  vendorDetails={this.props.vendorDetails}
                  setFetching={this.setFetching}
                  onboardingStatus={this.props?.onboardingStatus}
                />
              </div>
            )}
            {getUserRolePermission(
              RolePermissionConstants.VENDORPLATFORM_PREBOARDING_DOCUMENTCENTER,
              RolePermissionConstants.ALL
            ) === RolePermissionConstants.NONE && (
              <div>
                <div>
                  <Row>
                    <Header
                      title={Constants.DOCUMENT_CENTER}
                      vendorProfileId={this.props.vendorId}
                      onboardingStatus={this.props?.onboardingStatus}
                    />
                  </Row>
                </div>
                <ErrorContainer
                  errorMsg={
                    RolePermissionConstants.VMP_DOCUMENTCENTER_PAGE_ACCESS_ERROR_MSG
                  }
                  errorStatus={true}
                  errorStyle="errorMessage"
                />
              </div>
            )}
          </React.Fragment>
        )}
      </fieldset>
    );
  }
}

const mapStateToProps = ({ common }) => ({
  vendorCorpName: common.vendorCorpName,
  duns: common.duns,
  onboardingStatus: common.boardingStatuses?.onboardingStatus,
});

export default connect(mapStateToProps, null)(DocumentCenter);
